import classNames from "classnames";
import searchIcon from "images/search-icon.svg";
import React from "react";

import styles from "./SearchInput.module.css";

type Props = {
  className?: string;
  value: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
};

export default function SearchInput(props: Props) {
  return (
    <div className={classNames(styles.container, props.className)}>
      <img className={styles.image} src={searchIcon} alt="" />
      <input
        type="search"
        className={styles.input}
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.onChange}
      />
    </div>
  );
}
